import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
export class ApiConstant {
public apiURL: string = 'https://api-internal.tunaiku.com';
public gatewayUrl: string = 'https://tnk-gateway.tunaiku.com';
public trackingApi: string = 'https://api-tracking.tunaiku.com';
public partnerApiURL: string = 'https://api-partner.tunaiku.com';
public trackerURLDoAf: string = 'https://tracker2.doaffiliate.net';
public trackerURLFinAf: string =
    'https://affmanagement.postaffiliatepro.com/scripts/sale.php';
public trackerURLLinkProfAf: string = 'https://cpa.linkprofit.ru/sale';
public trackerURLLinkFazzCard: string =
    'https://secure.fazzcard.com/v1/transactions/complete/tunaiku';
public trackerURLLinkCashTree: string =
    'http://ext.ctree.id/adnetworks/postback/global?event=llatsni_eerthsac';
public tunaikuClient = 'https://tunaiku.com';
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ApiConstant_tsickle_Closure_declarations() {
/** @type {?} */
ApiConstant.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ApiConstant.ctorParameters;
/** @type {?} */
ApiConstant.prototype.apiURL;
/** @type {?} */
ApiConstant.prototype.gatewayUrl;
/** @type {?} */
ApiConstant.prototype.trackingApi;
/** @type {?} */
ApiConstant.prototype.partnerApiURL;
/** @type {?} */
ApiConstant.prototype.trackerURLDoAf;
/** @type {?} */
ApiConstant.prototype.trackerURLFinAf;
/** @type {?} */
ApiConstant.prototype.trackerURLLinkProfAf;
/** @type {?} */
ApiConstant.prototype.trackerURLLinkFazzCard;
/** @type {?} */
ApiConstant.prototype.trackerURLLinkCashTree;
/** @type {?} */
ApiConstant.prototype.tunaikuClient;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
